module.exports = __webpack_public_path__ + "img/ME.c82c1a80.svg";